import { AnimationBuilder, AnimationPlayer, AnimationReferenceMetadata, useAnimation } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { delay, interval, Observable, take, takeWhile, tap } from 'rxjs';

@Component({
  selector: 'csl-animate-icon',
  templateUrl: './animated-icon.component.html',
})
export class AnimateIconComponent implements AfterViewInit {
  @Input() animationMetadata: AnimationReferenceMetadata;
  @Input() interval = 10000;
  @Input() animStop = false;

  @ViewChildren(MatIcon) private readonly icon: QueryList<MatIcon>;

  player: AnimationPlayer;

  icon$: Observable<QueryList<MatIcon>>;
  loop$: Observable<number>;

  constructor(private _builder: AnimationBuilder) {}

  ngAfterViewInit(): void {
    this.icon$ = this.icon.changes.pipe(
      take(1),
      delay(0),
      tap(() => this.makeAnimation(this.icon.last._elementRef))
    );
  }

  makeAnimation(element: ElementRef) {
    const myAnimation = this._builder.build(useAnimation(this.animationMetadata));

    this.player = myAnimation.create(element.nativeElement);
    this.startAnimation();
  }

  startAnimation() {
    this.loop$ = interval(this.interval).pipe(
      takeWhile(() => !this.animStop),
      tap(() => this.player.play())
    );
  }
}
